import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { postUsersData, verifytoken } from '../../../../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../../../commonClass/Session';
import { formatDateyearmonthday, isNullable, onlyNumeric } from '../../../../../commonClass/CommonValidation';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { activityRateInventoryOpen } from '../../../../../../_actions/user.action';
import CustomColumn from '../../../../../../customControl/CustomColumn';

const ActivityRatesModal = (props) => {
    const { title,
        isEdit,
        selectedCellDate,
        availabilityDates,
        setOpenModal,
        ActivityBasicInfoId,
        UserId,
        ActivityName,
        dropDownList,
        dropdownData
    } = props;
    const dispatch = useDispatch();
    const [isSave, setIsSave] = useState(true);
    const [apiError, setApiError] = useState('');
    const [closedMessage, setClosedMessage] = useState('')

    const [formValue, setFormValue] = useState({
        ActivityBasicInfoId: ActivityBasicInfoId,
        FromDateSelect: selectedCellDate || null,
        ToDateSelect: selectedCellDate || null,
        FromDate: formatDateyearmonthday(selectedCellDate) + 'T:00:00:00' || null,
        ToDate: formatDateyearmonthday(selectedCellDate) + 'T:00:00:00' || null,
        ActivityManageActivitySlotId: dropDownList?.slotList ? dropDownList?.slotList?.map(el => el.value) : [],
        DayRangesId: 3,
        PricingTypeId: dropDownList?.basicData?.[0]?.PricingTypeId,
        IsBulk: false,
        PaxPriceDetails: [
            {
                ActivityManagePaxTypeId: 1,
                BasePrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.BasePrice,
                ActivityManageTaxId: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.ActivityManageTaxId,
                Commission: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.Commission,
                CommissionAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.CommissionAmount,
                ETMMarkup: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.ETMMarkup,
                NetPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.NetPrice,
                NetMarkupAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.NetMarkupAmount,
                MarkupTax: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.MarkupTax,
                DisplayPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.DisplayPrice
            },
            {
                ActivityManagePaxTypeId: 2,
                BasePrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.BasePrice,
                ActivityManageTaxId: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.ActivityManageTaxId,
                Commission: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.Commission,
                CommissionAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.CommissionAmount,
                ETMMarkup: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.ETMMarkup,
                NetPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.NetPrice,
                NetMarkupAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.NetMarkupAmount,
                MarkupTax: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.MarkupTax,
                DisplayPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.DisplayPrice
            },
            {
                ActivityManagePaxTypeId: 3,
                BasePrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.BasePrice,
                ActivityManageTaxId: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.ActivityManageTaxId,
                Commission: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.Commission,
                CommissionAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.CommissionAmount,
                ETMMarkup: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.ETMMarkup,
                NetPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.NetPrice,
                NetMarkupAmount: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.NetMarkupAmount,
                MarkupTax: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.MarkupTax,
                DisplayPrice: dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.DisplayPrice,
                MaximumPersonCapacity : dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.MaximumPersonCapacity
            }
        ],
        UserId: UserId,
    });

    const [formError, setFormError] = useState({})

    const roundValue = (num) => { return Number(Math.round(Number(num))); }
    const getAmountOfPercentage = (isPercenatge, basePrice, value) => {
        const amount = isPercenatge ? ((basePrice * value) / 100) : value;
        return roundValue(amount);
    }
    const priceCalculation = (
        ActivityManagePaxTypeId = 0,
        PricingTypeId,
        BasePriceString,
        ActivityManageTaxId,
        CommissionString,
        ETMMarkupString
    ) => {

        // (Base price - Commission) + tax = Net Vendor Amount
        // Vendor Amount + (ETM Markup + Markup tax) = Display Amount

        let priceData = {};
        const BasePrice = BasePriceString ? roundValue(BasePriceString) : BasePriceString;
        const Commission = CommissionString ? roundValue(CommissionString) : CommissionString;
        const ETMMarkup = ETMMarkupString ? roundValue(ETMMarkupString) : ETMMarkupString;

        if (
            !isNullable?.includes(PricingTypeId) &&
            !isNullable?.includes(BasePrice) &&
            !isNullable?.includes(Commission) &&
            !isNullable?.includes(ETMMarkup) &&
            !isNullable?.includes(ActivityManageTaxId)
        ) {
            const isPercentage = PricingTypeId === 1 ? true : false;

            const TaxPercentage = dropdownData?.taxList?.find((prev) => prev?.value === ActivityManageTaxId)?.TaxValue;

            const CommissionAmount = getAmountOfPercentage(isPercentage, BasePrice, Commission);
            const BeforeTax = roundValue(BasePrice - CommissionAmount);
            const TaxPercentageAmount = getAmountOfPercentage(true, BeforeTax, TaxPercentage);

            const NetPrice = roundValue(BeforeTax + TaxPercentageAmount);

            const NetMarkupAmount = getAmountOfPercentage(isPercentage, NetPrice, ETMMarkup);
            const MarkupTax = getAmountOfPercentage(true, NetMarkupAmount, TaxPercentage);

            const DisplayPrice = roundValue(NetPrice + NetMarkupAmount + MarkupTax);

            priceData = {
                ActivityManagePaxTypeId,
                BasePrice,
                ActivityManageTaxId,
                TaxPercentage,
                TaxPercentageAmount,
                Commission,
                CommissionAmount,
                ETMMarkup,
                NetMarkupAmount,
                MarkupTax,
                NetPrice,
                DisplayPrice
            }
            // }
        }
        else {
            priceData = null
        }

        return priceData;
    }

    const Calculate = (ActivityManagePaxTypeId, ETMMarkup) => {
        const Data = priceCalculation(
            ActivityManagePaxTypeId,
            formValue?.PricingTypeId,
            formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === ActivityManagePaxTypeId)?.BasePrice?.toString(),
            formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === ActivityManagePaxTypeId)?.ActivityManageTaxId,
            formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === ActivityManagePaxTypeId)?.Commission?.toString(),
            ETMMarkup?.toString()
        );

        setFormValue((prev) => ({
            ...prev,
            PaxPriceDetails: prev.PaxPriceDetails.map((item) =>
                item.ActivityManagePaxTypeId === ActivityManagePaxTypeId
                    ? {
                        ...item,
                        DisplayPrice: Data?.DisplayPrice,
                        ETMMarkup: Data?.ETMMarkup,
                        MarkupTax: Data?.MarkupTax,
                        NetMarkupAmount: Data?.NetMarkupAmount,
                        NetPrice: Data?.NetPrice
                    }
                    : item
            )
        }));
    }

    const onChange = (name, value) => {
        setFormError({});
        setApiError('')
        setIsSave(false);
        if (name === "ActivityManageActivitySlotId") {
            setFormValue(form => ({ ...form, [name]: value ? value?.map(el => el?.value) : [] }))
        }
        else {
            setFormValue(form => ({ ...form, [name]: value }))
        }
    }

    const handlePriceChange = (paxtypeId, name, value) => {
        setFormError({});
        setApiError('')
        setIsSave(false);
        setFormValue((prev) => ({
            ...prev,
            PaxPriceDetails: prev.PaxPriceDetails.map((item) =>
                item.ActivityManagePaxTypeId === paxtypeId
                    ? { ...item, [name]: value }
                    : item
            )
        }));
        Calculate(paxtypeId, value)
    }

    const handleDateRange = (update, isEdit) => {
        setFormError({});
        setApiError('')
        setIsSave(false);
        if (isEdit) {
            setFormValue(form => ({
                ...form,
                FromDate: formatDateyearmonthday(update),
                FromDateSelect: update,
                ToDate: formatDateyearmonthday(update),
                ToDateSelect: update,
            }))
        }
        else {
            setFormValue(form => ({
                ...form,
                FromDate: formatDateyearmonthday(update[0]),
                FromDateSelect: update[0],
                ToDate: formatDateyearmonthday(update[1]),
                ToDateSelect: update[1],
            }))
        }
    }

    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };

    const onClose = () => {
        isSave ? setOpenModal(false) : setClosedMessage(true);
    }

    const YesProceed = (e) => {
        e.preventDefault()
        setOpenModal(false)
        setClosedMessage(false)
    }

    const NoProceed = (e) => {
        e.preventDefault()
        setClosedMessage(false)
    }

    const validateData = () => {
        let status = true;
        let error = {};

        if (isEdit) {
            if (formValue?.FromDateSelect === null) {
                error["FromDateSelect"] = "Date selection is mandatory.";
                status = false;
            }
        }
        else {
            if (formValue?.FromDateSelect === null || formValue?.ToDateSelect === null) {
                error["date"] = "Date selection is mandatory.";
                status = false;
            }
        }
        if (formValue?.DayRangesId <= 0) {
            error["DayRangesId"] = " Please select days.";
            status = false;
        }
        if (formValue?.ActivityManageActivitySlotId?.length === 0) {
            error["ActivityManageActivitySlotId"] = "Please select slots.";
            status = false;
        }
        if (dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)) {
            if (!formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.ETMMarkup) {
                error["Adultmarkup"] = "Cannot leave blank.";
                status = false;
            }
        }
        if (dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)) {
            if (!formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.ETMMarkup) {
                error["Childmarkup"] = "Cannot leave blank.";
                status = false;
            }
        }
        if (dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)) {
            if (!formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.ETMMarkup) {
                error["Groupmarkup"] = "Cannot leave blank.";
                status = false;
            }
        }
        setFormError(error)
        return status;
    }

    //#region Fetch all API data
    const updateSelectedDayRate = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            formValue.IsBulk = isEdit ? false : true
            formValue.PaxPriceDetails = formValue?.PaxPriceDetails?.filter(el => (dropDownList?.paxPriceDetails?.map(obj => obj.ActivityManagePaxTypeId))?.includes(el.ActivityManagePaxTypeId))
            const inventory = await postUsersData('/master/v1/insertupdateactivitymanageinventoryratessingleorbulk', formValue);
            if (inventory.status) {
                setOpenModal(false);
                setFormError({})
                setIsSave(true);
                dispatch({ type: 'ALERTING', message: inventory.message });
                dispatch(activityRateInventoryOpen())
            } else {
                setApiError(inventory.message)
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    };

    const handleApply = (e) => {
        e.preventDefault();
        if (validateData()) {
            updateSelectedDayRate();
        }
    }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center bulk_update_modal_header">
                <div className="bulk_update_modal_title">
                    {title}
                </div>
                <div role='button' onClick={onClose}>
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>

            {closedMessage &&
                <div className="text-center pb-3">
                    <span className="text-danger">Unsaved data, do you want to close the window ? </span>
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => YesProceed(e)} > Yes </span>
                    or
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => NoProceed(e)} > No</span>.
                </div>
            }
            <form action="" className='py-2'>
                {apiError && <span className='text-danger text-center mt-2'>{apiError}</span>}
                <div className='row'>
                    <CustomColumn colNum={12} colLabel={12} colChildren={12} labelText='Activity Name' labelId='ActivityName' >
                        <input
                            type='text'
                            className='form-control'
                            name='ActivityName'
                            id="ActivityName"
                            value={ActivityName}
                            readOnly
                        />
                    </CustomColumn>
                    <CustomColumn colNum={4} colLabel={12} colChildren={12} labelText='Select Date' labelId='select-date' isRequired >
                        {
                            isEdit ?
                                <>
                                    <div className='position-relative'>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            className='form-control'
                                            id='select-date'
                                            selected={formValue?.FromDateSelect}
                                            placeholderText="Select Date"
                                            autoComplete='off'
                                            showMonthDropdown
                                            name='FromDateSelect'
                                            startDate={formValue?.FromDateSelect}
                                            onChange={(e) => handleDateRange(e, isEdit)}
                                            minDate={new Date() < new Date(availabilityDates?.StartDate) ? new Date(availabilityDates?.StartDate) : new Date()}
                                            maxDate={new Date(availabilityDates?.EndDate)}
                                        />
                                        <span className={`example-custom-input activityinventoryBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                            onClick={(e) => openDatePicker("select-date")}
                                        ><i className="fa fa-calendar"></i></span>
                                    </div>
                                    {formError?.FromDateSelect && <small className='text-danger text-center mt-2'>{formError?.FromDateSelect}</small>}
                                </>
                                :
                                <>
                                    <div className='position-relative'>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            className='form-control'
                                            id='select-date'
                                            selected={formValue?.FromDateSelect}
                                            placeholderText="Select Date Range"
                                            selectsRange={true}
                                            autoComplete='off'
                                            showMonthDropdown
                                            startDate={formValue?.FromDateSelect}
                                            endDate={formValue?.ToDateSelect}
                                            onChange={(e) => handleDateRange(e, isEdit)}
                                            minDate={new Date() < new Date(availabilityDates?.StartDate) ? new Date(availabilityDates?.StartDate) : new Date()}
                                            maxDate={new Date(availabilityDates?.EndDate)}
                                        />
                                        <span className={`example-custom-input activityinventoryBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                            onClick={(e) => openDatePicker("select-date")}
                                        ><i className="fa fa-calendar"></i></span>
                                    </div>
                                    {formError?.date && <small className='text-danger text-center mt-2'>{formError?.date}</small>}
                                </>
                        }
                    </CustomColumn>
                    <CustomColumn colNum={4} colLabel={12} colChildren={12} labelText='Days' labelId='select_days' isRequired >
                        <Select
                            name='Days'
                            className="dropdown select_dropdown"
                            options={dropDownList?.daysRangeList}
                            inputId='select_days'
                            value={dropDownList?.daysRangeList?.find((obj) => obj?.value === formValue?.DayRangesId) || null}
                            onChange={(e) => onChange("DayRangesId", e?.value ? e?.value : null)}
                            isSearchable
                            placeholder='Days'
                        />
                        {formError?.DayRangesId && <small className='text-danger text-center mt-2'>{formError?.DayRangesId}</small>}
                    </CustomColumn>
                    <CustomColumn colNum={4} colLabel={12} colChildren={12} labelText='Select Slots' labelId='Select_Slots' isRequired>
                        <Select
                            name='Days'
                            className="dropdown select_dropdown"
                            options={dropDownList?.slotList}
                            inputId='Select_Slots'
                            isMulti
                            value={dropDownList?.slotList?.filter((obj) => formValue?.ActivityManageActivitySlotId?.includes(obj?.value)) || null}
                            onChange={(e) => onChange("ActivityManageActivitySlotId", e ? e : null)}
                            isSearchable
                            placeholder='Select_Slots'
                        />
                        {formError?.ActivityManageActivitySlotId && <small className='text-danger text-center mt-2'>{formError?.ActivityManageActivitySlotId}</small>}
                    </CustomColumn>
                    <div className="row">
                        <CustomColumn colXLNum={4} colNum={6} colMDNum={6} colLabel={12} colChildren={12} labelText='Pricing Type' labelId='PricingTypeId' >
                            <Select
                                className="dropdown select_dropdown"
                                inputId='PricingTypeId'
                                options={dropdownData?.policyTypeList}
                                value={dropdownData?.policyTypeList?.filter((prev) => prev?.value === formValue?.PricingTypeId) || null}
                                isSearchable
                                isDisabled={true}
                                placeholder='Pricing Type'
                            />
                        </CustomColumn>

                        {dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1) && <CustomColumn colNum={12} colLabel={12} colChildren={12} classChildren="align-content-center" labelText='Adult' labelId='OperatedDays'>
                            <div className="row g-2 row-cols-2 row-cols-md-6 ">
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultBasePrice"
                                        id="adultBasePrice"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.BasePrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Base Price'
                                    />
                                </div>
                                <div className="col">
                                    <Select
                                        className="dropdown select_dropdown"
                                        inputId='adultActivityManageTaxId'
                                        options={dropdownData?.taxList}
                                        value={dropdownData?.taxList?.find((prev) => prev?.value === formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.ActivityManageTaxId) || 0}
                                        isSearchable
                                        isDisabled
                                        placeholder='Tax'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultCommission"
                                        id="adultCommission"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.Commission ?? ''}
                                        disabled
                                        placeholder='Commission'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultETMMarkup"
                                        id="adultETMMarkup"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.ETMMarkup ?? ""}
                                        onChange={(e) => {
                                            const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                            if (formValue?.PricingTypeId === 1) {
                                                numberValue <= 100 &&
                                                    handlePriceChange(1, "ETMMarkup", numberValue)
                                            }
                                            else {
                                                e?.target?.value?.length <= 4 &&
                                                    handlePriceChange(1, "ETMMarkup", numberValue)
                                            }
                                        }}
                                        maxLength={formValue?.PricingTypeId === 1 ? 3 : 4}
                                        placeholder='ETM Markup'
                                    />
                                    {formError?.Adultmarkup && <div className="text-danger text-start fs_14">{formError?.Adultmarkup}</div>}
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.NetPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Net Price'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 1)?.DisplayPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Display Price'
                                    />
                                </div>
                            </div>

                        </CustomColumn>}

                        {dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2) && <CustomColumn colNum={12} colLabel={12} colChildren={12} classChildren="align-content-center" labelText='Child' labelId='OperatedDays'>
                            <div className="row g-2 row-cols-2 row-cols-md-6 ">
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultBasePrice"
                                        id="adultBasePrice"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.BasePrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Base Price'
                                    />
                                </div>
                                <div className="col">
                                    <Select
                                        className="dropdown select_dropdown"
                                        inputId='adultActivityManageTaxId'
                                        options={dropdownData?.taxList}
                                        value={dropdownData?.taxList?.find((prev) => prev?.value === formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.ActivityManageTaxId) || 0}
                                        isSearchable
                                        isDisabled
                                        placeholder='Tax'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultCommission"
                                        id="adultCommission"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.Commission ?? ''}
                                        disabled
                                        placeholder='Commission'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultETMMarkup"
                                        id="adultETMMarkup"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.ETMMarkup ?? ""}
                                        onChange={(e) => {
                                            const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                            if (formValue?.PricingTypeId === 1) {
                                                numberValue <= 100 &&
                                                    handlePriceChange(2, "ETMMarkup", numberValue)
                                            }
                                            else {
                                                e?.target?.value?.length <= 4 &&
                                                    handlePriceChange(2, "ETMMarkup", numberValue)
                                            }
                                        }}
                                        maxLength={formValue?.PricingTypeId === 1 ? 3 : 4}
                                        placeholder='ETM Markup'
                                    />
                                    {formError?.Childmarkup && <div className="text-danger text-start fs_14">{formError?.Childmarkup}</div>}
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.NetPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Net Price'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 2)?.DisplayPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Display Price'
                                    />
                                </div>
                            </div>

                        </CustomColumn>}

                        {dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3) && <CustomColumn colNum={4} colLabel={12} colChildren={12} labelText='Max Person Allowed' labelId='MaximumPersonCapacity' >
                            <input
                                type="text"
                                className='form-control'
                                name="MaximumPersonCapacity"
                                id="MaximumPersonCapacity"
                                placeholder='Max Person Allowed'
                                value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.MaximumPersonCapacity ?? ''}
                                disabled
                                maxLength={1}
                            />
                        </CustomColumn>}

                        {dropDownList?.paxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3) && <CustomColumn colNum={12} colLabel={12} colChildren={12} classChildren="align-content-center" labelText='Pricing Per Group' labelId='OperatedDays'>
                            <div className="row g-2 row-cols-2 row-cols-md-6 ">
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultBasePrice"
                                        id="adultBasePrice"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.BasePrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Base Price'
                                    />
                                </div>
                                <div className="col">
                                    <Select
                                        className="dropdown select_dropdown"
                                        inputId='adultActivityManageTaxId'
                                        options={dropdownData?.taxList}
                                        value={dropdownData?.taxList?.find((prev) => prev?.value === formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.ActivityManageTaxId) || 0}
                                        isSearchable
                                        isDisabled
                                        placeholder='Tax'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultCommission"
                                        id="adultCommission"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.Commission ?? ''}
                                        disabled
                                        placeholder='Commission'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        name="adultETMMarkup"
                                        id="adultETMMarkup"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.ETMMarkup ?? ""}
                                        onChange={(e) => {
                                            const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                            if (formValue?.PricingTypeId === 1) {
                                                numberValue <= 100 &&
                                                    handlePriceChange(3, "ETMMarkup", numberValue)
                                            }
                                            else {
                                                e?.target?.value?.length <= 4 &&
                                                    handlePriceChange(3, "ETMMarkup", numberValue)
                                            }
                                        }}
                                        maxLength={formValue?.PricingTypeId === 1 ? 3 : 4}
                                        placeholder='ETM Markup'
                                    />
                                    {formError?.Groupmarkup && <div className="text-danger text-start fs_14">{formError?.Groupmarkup}</div>}
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.NetPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Net Price'
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={formValue?.PaxPriceDetails?.find(el => el.ActivityManagePaxTypeId === 3)?.DisplayPrice ?? ''}
                                        maxLength={6}
                                        disabled
                                        placeholder='Display Price'
                                    />
                                </div>
                            </div>

                        </CustomColumn>}

                    </div>
                    <div className="col-12">
                        <button type="button" className='btn bulk_apply_btn btn-primary w-100' onClick={(e) => handleApply(e)}>Apply</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default ActivityRatesModal